module.exports = __webpack_public_path__ + "img/corporativo-rh.a4bff55a.png";